import script from "./map_switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./map_switcher.vue?vue&type=script&setup=true&lang=js"

import "./map_switcher.vue?vue&type=style&index=0&id=3c3fa1de&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3fa1de"]])

export default __exports__